import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

import type { ProjectLanguageServerResponse, SimpleLanguage } from './types';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const ProjectLanguagesList = lazy(() => import('.'));

class ProjectLanguagesListComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['languages', 'is-admin', 'all-languages'];
    }

    render() {
        const languages = this.jsonProp<ProjectLanguageServerResponse[]>('languages');
        const isAdmin = !!this.jsonProp('is-admin');
        const allLanguages = this.jsonProp<SimpleLanguage[]>('all-languages') ?? [];

        return (
            <RootProviders>
                <ProjectLanguagesList languages={languages || []} isAdmin={isAdmin} allLanguages={allLanguages} />
            </RootProviders>
        );
    }
}

customElements.define('project-languages-list', ProjectLanguagesListComponent);
